import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

export default function UnansweredBadge(props) {
    const { contentId, count, onClick } = props;
    if (count > 0) {
        const badgeContent = (
            <span>
                <span className="badge unread-count">{count}</span>
                {` Unanswered Question${count === 1 ? '' : 's'}`}
            </span>
        );

        if (Array.isArray(contentId)) {
            return <div>{badgeContent}</div>;
        }
        return (
            <div>
                <Link
                    to={{
                        pathname: `notes/content-${contentId}`,
                        query: { unansweredQuestions: true },
                    }}
                    className="unanswered"
                    onClick={onClick}
                >
                    {badgeContent}
                </Link>
            </div>
        );
    }
    // At least with React 0.13, returning null here causes React to replace
    // the `<noscript` placeholder every time.
    // TODO: Try null here when we upgrade to React 15
    return <span />;
}
UnansweredBadge.propTypes = {
    contentId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number),
    ]).isRequired,
    count: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/unanswered_badge.jsx